import { Button } from '@ksyos/design-system';
import { useState } from 'react';
import { getSelectedLanguage } from '@frontend/translate';
import type { IDevice } from './DeviceDetails';
import { DevicesInformationLogbookModal } from './DevicesInformationLogbookModal';

type DeviceInformationCardReadFooter = {
    device: Pick<IDevice, 'id'>;
};

export function DeviceInformationCardReadFooter(props: Readonly<DeviceInformationCardReadFooter>) {
    const translate = getSelectedLanguage();

    const { device } = props;

    const [showLogbookModal, setShowLogbookModal] = useState(false);

    return (
        <>
            <Button
                onClick={() => setShowLogbookModal(true)}
                variant="link"
            >
                {translate.devices.logbook}
            </Button>
            <DevicesInformationLogbookModal
                device={device}
                isOpen={showLogbookModal}
                onClose={handleClose}
            />
        </>
    );

    function handleClose() {
        setShowLogbookModal(false);
    }
}
